import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

// MANTINE IMPORTS
import "@mantine/carousel/styles.css";
import {
  createTheme as createMantineTheme,
  MantineProvider,
} from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";

import { Notifications } from "@mantine/notifications";

import Login from "./Pages/Login";

import Assessments from "./Pages/Assessments";
import CompleteOnboarding from "./Pages/CompleteOnboarding";
import CourseMaterials from "./Pages/CourseMaterials";
import Courses from "./Pages/Courses";
import Dashboard from "./Pages/Dashboard";
import NotFound from "./Pages/NotFound";
import OngoingLesson from "./Pages/OngoingLesson";
import Overview from "./Pages/Overview";
import Profile from "./Pages/Profile";
import SingleAssessment from "./Pages/SingleAssessment";
import SingleCourse from "./Pages/SingleCourse";
import "./styles/index.scss";
const mantineTheme = createMantineTheme({});
const RedirectWhereNecessary = () => {
  const token = localStorage.getItem("t");
  if (token) {
    return <Navigate to="/d" />;
  } else {
    window.location.href = "/login";
    return <></>;
  }
};
const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <RedirectWhereNecessary />,
  },
  {
    path: "/onboard/:token",
    element: <CompleteOnboarding />,
  },
  {
    path: "/d",
    element: <Dashboard />,
    children: [
      {
        path: "/d/overview",
        element: <Overview />,
      },

      {
        path: "/d/courses",
        element: <Courses />,
      },
      {
        path: "/d/course/:courseID",
        element: <SingleCourse />,
      },
      {
        path: "/d/ongoing/:lessonID",
        element: <OngoingLesson />,
      },
      {
        path: "/d/lesson/assessments/:lessonID",
        element: <Assessments />,
      },
      {
        path: "/d/assessment/:assessmentID",
        element: <SingleAssessment />,
      },
      {
        path: "/d/lesson/materials/:lessonID",
        element: <CourseMaterials />,
      },

      {
        path: "/d/profile",
        element: <Profile />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default function App() {
  return (
    <MantineProvider theme={mantineTheme}>
      <Notifications
        styles={{
          root: {
            zIndex: 9999999999999,
          },
        }}
        position="bottom-right"
      />
      <RouterProvider router={router} />
    </MantineProvider>
  );
}
